import { GlButton } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { isLoggedIn } from '~/lib/utils/common_utils';
import NoteSignedOutWidget from './note_signed_out_widget.vue?vue3';
import NewLineDiscussionForm from './new_line_discussion_form.vue?vue3';
import DiffDiscussions from './diff_discussions.vue?vue3';
import DraftNote from './draft_note.vue?vue3';
export default {
    name: 'DiffLineDiscussions',
    components: {
        GlButton,
        NoteSignedOutWidget,
        NewLineDiscussionForm,
        DiffDiscussions,
        DraftNote
    },
    inject: {
        userPermissions: {
            type: Object
        }
    },
    props: {
        discussions: {
            type: Array,
            required: true
        },
        collapsed: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'start-thread',
        'highlight',
        'clear-highlight'
    ],
    data () {
        return {
            isLoggedIn: isLoggedIn()
        };
    },
    computed: {
        regularDiscussions () {
            return this.discussions.filter((discussion)=>!discussion.isDraft);
        },
        draftDiscussions () {
            return this.discussions.filter((discussion)=>discussion.isDraft);
        },
        hasForm () {
            return this.discussions.some((discussion)=>discussion.isForm);
        }
    },
    methods: {
        lineRange (discussion) {
            const { position } = discussion;
            if (position?.line_range) return position.line_range;
            return {
                start: {
                    old_line: position?.old_line,
                    new_line: position?.new_line
                },
                end: {
                    old_line: position?.old_line,
                    new_line: position?.new_line
                }
            };
        },
        onMouseenter (discussion) {
            this.$emit('highlight', this.lineRange(discussion));
        },
        onMouseleave () {
            this.$emit('clear-highlight');
        }
    }
};
